<style>
  .linc-tariff-input {
    width: 10vh;
  }
  .linc-text {
    width: 10vh;
    margin-top: 1vh;
  }
</style>

<template>

  <div class="form-group">

      <h4>{{ $t('management.unit.softwaresettings.tariffspanel.transaction_fee') }}</h4>
      <div class="form-group--three-columns">
      <ul>
        <li v-for="(item, index) in companyTariffs">
          <div class="form-row">
          <p class="linc-text">{{ item.company }}:</p>
          <el-input class="linc-tariff-input"
                v-model="companyTariffs[index].transactionTariff"
                type="number"
                min="0"
                @change="updateSettings()"
                :disabled="!overridden"
          ></el-input>
          </div>
        </li>
      </ul>
      </div>

      <h4>{{ $t('management.unit.softwaresettings.tariffspanel.value_fee') }}</h4>

      <el-table :data="companyTariffs" class="inventoryTable" style="width: 100%;">

      <el-table-column min-width="15%" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.company }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="'0.05'" min-width="15%" align="center">
        <template slot-scope="scope">
          <el-form-item class="custom-label">
            <el-input v-model="scope.row.valueTariffs[0].tariff" type="number" min="0" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column :label="'0.10'" min-width="15%" align="center">
        <template slot-scope="scope">
          <el-form-item class="custom-label">
            <el-input v-model="scope.row.valueTariffs[1].tariff" type="number" min="0" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column :label="'0.20'" min-width="15%" align="center">
        <template slot-scope="scope">
          <el-form-item class="custom-label">
            <el-input v-model="scope.row.valueTariffs[2].tariff" type="number" min="0" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column :label="'0.50'" min-width="15%" align="center">
        <template slot-scope="scope">
          <el-form-item class="custom-label">
            <el-input v-model="scope.row.valueTariffs[3].tariff" type="number" min="0" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column :label="'1.00'" min-width="15%" align="center">
        <template slot-scope="scope">
          <el-form-item class="custom-label">
            <el-input v-model="scope.row.valueTariffs[4].tariff" type="number" min="0" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column :label="'2.00'" min-width="15%" align="center">
        <template slot-scope="scope">
          <el-form-item class="custom-label">
            <el-input v-model="scope.row.valueTariffs[5].tariff" type="number" min="0" @change="updateSettings()" :disabled="!overridden || readOnly"></el-input>
          </el-form-item>
        </template>
      </el-table-column>

      </el-table>

  </div>

</template>

<script>

  export default {
    name: 'DqTariffspanel',
    replace: true,
    props: {
      label: '',
      overridden: false,
      companyTariffs: [],
      readOnly: false
    },
    data: function () {
      return {
        companyTariffsNew: [...this.companyTariffs]
      }
    },
    mounted () {
      this.updateSettings()
    },
    watch: {
      tariffsSettings: function () {
        this.updateSettings()
      }
    },
    methods: {
      updateSettings () {
        this.companyTariffsNew = [...this.companyTariffs]
        this.$store.commit('overrideTariffSettings/setOverrideTariffSettings', { companyTariffs: this.companyTariffsNew })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// tariffspanel.vue?db2b4772